import { cn } from 'src/utils/cn';

interface LoaderProps {
  readonly className?: string;
}

const Loader = ({ className }: LoaderProps) => {
  return (
    <div
      data-testid="loader"
      className={cn(
        'flex justify-center items-center w-full h-full',
        className,
      )}
    >
      <div className="w-16 h-16 aspect-square max-w-full max-h-full border-4 border-t-4 border-gray-200 border-t-True-Blue rounded-full animate-spin"></div>
    </div>
  );
};

export default Loader;
